import handlerErrors from '../../../helpers/handlerErrorsAxios'

export default {
	async loginUser({commit, getters, state, dispatch}, credenciais)
	{
        credenciais.app_id = state.app_id
        let {data} = await getters.getService.post("loginServer/login", credenciais)

        if(!data.dados) return data

        let {usuario, token, menu} = data.dados
        commit("SET_USER", usuario)
        commit("SET_TOKEN", token)
        let userLocal = await dispatch('loadUserLocal')


        let indexProtaxi = menu.findIndex( _ => _.rota == "menuprotaxi" )
        if( indexProtaxi != -1 && (!userLocal.data || !userLocal.data.protaxi || !userLocal.data.protaxi.audio_cliente || !userLocal.data.protaxi.audio_motorista || !userLocal.data.protaxi.callerid || !userLocal.data.protaxi.voip_passageiro || !userLocal.data.protaxi.voip_motorista) )
           menu.splice(indexProtaxi, 1)

        if(userLocal.data) {
            commit("SET_MENU", menu)
            return data
        } else {
            await dispatch('logout')
            return userLocal
        }
    },
    async redefineSenha({commit, getters}, email)
    {
        let {data} = await getters.getService.get(`loginServer/redefinir/gerar/${email}/${getters.getAppID}`)
        return data
    },

    async loadUserLocal ({commit, getters}) {
        let {data} = await getters.getApi.get(`user/${getters.getUser._id}`)
        commit('SET_USER_LOCAL', data.data ? data.data : {})
        return data
    },

    async loadApplication({getters, commit}, app_id)
    {
        let { data, status } = await getters.getService.get(`loginServer/apps/appversion/${app_id}`)
        await commit('SET_APPVERSION', data.versoes)
        return  await data.status
    },

    subroutes({commit}, routes)
    {
       commit('SET_ROUTES', routes)
    },

	async save_webhook_response_sms({commit, getters}, {_id, uri_response_sms})
	{
        let {data} = await getters.getApi.put("user/update_webhook_sms", {_id, uri_response_sms})
        return data.status
    },

	async logout({commit, getters})
	{
        let {data} = await getters.getService.get("loginServer/logout")
        if(data.status)
        {
            commit('LOGOUT')
        }
    },

    async getFiltroQueroTaxi({ getters }, filtros) {
        try {
            const { dt_ini, dt_fim, empresa_id } = filtros
            const url = empresa_id ?
            `/filtros/pedidos/${dt_ini}/${dt_fim}/empresa/${empresa_id}`
            :
            `/filtros/pedidos/${dt_ini}/${dt_fim}`

            const { data } = await getters.getQuerotaxiApi.get(url)

            return data
        } catch(err) {
            return {
                status: false,
                pedidos: [],
                message: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Não foi posível realizar o filtro'
            }
        }
    },

    async isClientQueroTaxi({ commit, getters }, astandes_token) {
        try {
            const sha256 = require('js-sha256')
            const { data } = await getters.getQuerotaxiApi.get(`/is-client/astandes_token/${sha256(astandes_token)}`)

            if(data.status) commit('SET_EMPRESA_QUERO_TAXI', data.empresa)

            return data
        } catch (err) {
            console.log('Erro: ', err)
            return {
                status: false
            }
        }
    },

    async loadPedidosQueroTaxi({ getters }, obj) {
        try {
            const { data } = await getters.getQuerotaxiApi.get(`/pedidos/empresa/${obj.empresa_id}`, { params: obj.params })

            return data
        } catch (err) {
            console.log('Erro: ', err)
            return { status: true }
        }
    },

    async createTicketQueroTaxi({getters}, { dominio,token,telefone}){
        try {
            const axios = require('axios')

            const request = axios.create({
                baseURL: `https://${dominio}`,
                headers: { Authorization: token }
            })

            const { data } = await request.post('/create_ticket', { telefone })

            return data
        } catch (err) {
            console.log('Erro: ', err)
            return { status: false }
        }
    },

    async loadAllCampaniesQueroTaxi({ getters }) {
        try {
            const { data } = await getters.getQuerotaxiApi.get('/empresas')

            return data
        } catch (err) {
            return { status: false }
        }
    },

    async createOrEditQueroTaxi({ getters }, empresa) {
        try {
            const { data } = await getters.getQuerotaxiApi.post('/empresas', empresa)

            return data
        } catch (err) {
            return handlerErrors(err)
        }
    },

    async removeCompanyQueroTaxi({ getters }, id) {
        try {
            const { data } = await getters.getQuerotaxiApi.delete('/empresas/'+id)

            return data
        } catch (err) {
            return handlerErrors(err)
        }
    },

    async cahngeStatusQueroTaxi({ getters }, { id, status }) {
        try {
            const { data } = await getters.getQuerotaxiApi.put('/empresas', { id, status })

            return data
        } catch (err) {
            return handlerErrors(err)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/system/actions.js